var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / BY") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-BY",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E54252",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 13.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#5CBE6B",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L4,2.999 L3.33333333,4 L4,5.001 L4,6.999 L3.33333333,8 L4,9.001 L4,10.999 L3.33333333,12 L4,13.001 L4,14.999 L3.33333333,16 L4,17.001 L4,20 L0,20 L0,0 L4,0 Z",
    id: "Rectangle-1512",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.666666667,14 L0.666666667,16 L-0.666666667,18 L-2,16 L-0.666666667,14 Z M-0.666666667,10 L0.666666667,12 L-0.666666667,14 L-2,12 L-0.666666667,10 Z M-0.666666667,6 L0.666666667,8 L-0.666666667,10 L-2,8 L-0.666666667,6 Z M-0.666666667,2 L0.666666667,4 L-0.666666667,6 L-2,4 L-0.666666667,2 Z",
    id: "Rectangle-1513",
    fill: "#E54252",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,16 L3.33333333,18 L2,20 L0.666666667,18 L2,16 Z M2,12 L3.33333333,14 L2,16 L0.666666667,14 L2,12 Z M2,8 L3.33333333,10 L2,12 L0.666666667,10 L2,8 Z M2,4 L3.33333333,6 L2,8 L0.666666667,6 L2,4 Z M2,0 L3.33333333,2 L2,4 L0.666666667,2 L2,0 Z",
    id: "Rectangle-1513",
    fill: "#E54252",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBy);
export default __webpack_public_path__ + "static/media/BY.21edfa1bb156a803cb4a4f50d1c73560.svg";
export { ForwardRef as ReactComponent };